/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Created
 * 
 * 1 = Released
 * 
 * 2 = InProgress
 * 
 * 3 = QaHold
 * 
 * 4 = Cancelled
 * 
 * 5 = Complete
 */
export enum WorkOrderStatus {
  Created = 0,
  Released = 1,
  InProgress = 2,
  QaHold = 3,
  Cancelled = 4,
  Complete = 5
}
